module.exports = __webpack_public_path__ + "static/media/7x7GoodOptimized.096fc78b.jp2";